export const Constants = {
    API: {
        AUTH: '/auth',
        VERIFY_OTP: '/auth/verify',
        USER: '/users',
        MESSAGE: '/messages',
        UPLOAD: '/upload',
        WEBHOOK: '/webhooks',
        BRAZE_WEBHOOK: '/braze-webhooks',
        DASHBOARD: '/dashboard',
        BLACKLIST: '/blacklists'
    }
}
